import React from 'react';

import { alertSuccess } from '@dashboard/contexts/SnackbarManager/store';
import { useSendDomainNameVerificationApprovedEmailMessageMutation } from '@dashboard/generated/wp/administrator';
import { Button } from '@mui/material';

type Props = {
  id: string;
};
export default function SendConfirmationButton({ id }: Props) {
  const [executeMutation, { loading }] = useSendDomainNameVerificationApprovedEmailMessageMutation();
  const onClick = async () => {
    const confirmed = window.confirm('Are you sure you want to send the approval email?');
    if (!confirmed) return;

    await executeMutation({ variables: { id } });
    alertSuccess('Approval email sent');
  };

  return (
    <Button variant="outlined" disabled={loading} type="button" onClick={onClick}>
      Send approval email
    </Button>
  );
}
